@for (menuItem of menuItemSpecs; track trackById($index, menuItem)) {
  <div #accordionHeader (click)="loadSubMenu($event, menuItem)" class="accordion-header" attr.id="{{menuIdV1(menuItem)}}" [attr.menuIndex]="menuItem.menuIndex" [attr.selected]="menuItem.selected">
    <!--
    do we need an id just for hte expander since clicking anywhere will trigger the expansion
    attr.id="{{menuItem.id}}_expander"
    -->
    @if (menuItem.menu) {
      <button aria-hidden="true" class="btn hide-focus" type="button" (click)="loadSubMenu($event, menuItem)">
        <span class="icon plus-minus" aria-hidden="true" role="presentation"></span>
      </button>
    }
    <!-- must use href="#" here so that soho will handle expanding a sub menu when clicking on the text -->
    <a class="router-link-active"
      href="#"
      attr.aria-label="{{menuItem?.webAppTitle || menuItem?.label}}"
      attr.resource-type="{{menuItem.resourceType}}"
      attr.data-automation-id="{{dataAutomationId(menuItem)}}"
      attr.id="{{menuIdV2(menuItem)}}"
      (click)="onMenuItemClicked($event, menuItem)"
      (contextmenu)="onMenuItemRightClicked($event, menuItem)"
      >
      <span>{{menuItem?.webAppTitle || menuItem?.label}}</span>
    </a>
  </div>
  @if (menuItem.menu) {
    <lm-application-menu-submenu
      class="accordion-pane has-icons"
      [inSearchResultsMenu]="inSearchResultsMenu"
      [menuItemSpecs]="menuItem.menu"
      (menuLoaded)="onMenuLoaded($event)"
      [attr.link]="menuItem.link">
    </lm-application-menu-submenu>
  }
}
<div #menuFormDialog>
  <!-- dialog placeholder used to display action form from menu -->
</div>
